<template>
  <div class="login-block">
    <div class="login-title">
      <h5>密码登录</h5>
      <p>{{ errMessage }}</p>
    </div>
    <el-form
      ref="loginForm"
      class="login-form"
      :model="loginForm"
      :rules="rules"
      :show-message="false"
      size="medium"
    >
      <el-form-item prop="name">
        <el-input
          :value="loginForm.name"
          @input="handleInputAccount"
          maxlength="30"
          clearable
          placeholder="账户"
          v-on:keyup.enter.native="doLogin"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password" class="pass">
        <el-input
          v-model="loginForm.password"
          maxlength="20"
          placeholder="密码"
          show-password
          v-on:keyup.enter.native="doLogin"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="link-box clearfix">
      <span class="fl primary link" @click="$emit('update', 'loginM')"
        >短信登录</span
      >
      <router-link
        class="fr link"
        :to="{ path: '/recovery', query: $route.query }"
        replace
        >忘记密码?</router-link
      >
    </div>
    <v-button @click="doLogin" :loading="loading">登&emsp;录</v-button>
  </div>
</template>

<script>
import aes from '@/uitls/aes'
import { setCookie } from '@/uitls/index'
import vButton from './vButton'

import mixinRedirect from '../utils/mixinRedirect'

export default {
  components: {
    vButton
  },
  mixins: [mixinRedirect],
  data() {
    return {
      loading: false,
      errMessage: '',
      // 表单
      loginForm: {
        account: '',
        name: '',
        password: ''
      },
      rules: {
        name: [{ required: true, message: '请输入账号', trigger: 'change' }],
        password: [{ required: true, message: '请输入密码', trigger: 'change' }]
      }
    }
  },
  methods: {
    handleInputAccount(val) {
      const s = val.replace(/[\s]/g, '')
      this.loginForm.name = s
      // case: account end with "@vanke.com"
      this.loginForm.account = s.replace(/@vanke\.com$/, '')
    },
    /* enable loading on v-button */
    doLoading() {
      this.loading = true
    },
    /* close loading on v-button */
    doCloseLoading() {
      this.loading = false
    },
    /* check privacy status */
    doCheckPrivacy() {
      this.$http
        .post(
          '/user-server/agreement/check',
          {
            version: process.env.PRIVACY_VER
            // TODO: aes.Encrypt(process.env.PRIVACY_VER)
          },
          {
            headers: {
              Authorization: this.$store.state.index.dataTokn
            },
            interceptorDisabled: true
          }
        )
        .then(({ data: { code, value, message } }) => {
          this.doCloseLoading()
          if (code == 200) {
            if (value) {
              // set token to cookie and then redirect
              this.doSetCookie()
              this.doRedirect()
            } else {
              // user haven't agree yet
              this.$emit('update', 'privacyA')
            }
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.doCloseLoading()
          console.log('ERROR', err)
        })
    },
    /* set token into cookie */
    doSetCookie() {
      setCookie('accesstoken', this.$store.state.index.dataTokn, 1)
    },

    /* login */
    doLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.doLoading()
          this.$http
            .post('/user-server/user/pc_login.do', {
              userAccount: this.loginForm.account,
              loginType: 1,
              password: aes.Encrypt(this.loginForm.password)
            })
            .then(({ data: { code, value, message } }) => {
              this.doCloseLoading()
              if (code == 200) {
                // set token to vuex
                this.$store.commit('index/setDataTokn', value)
                // check whether user have read privacy
                this.doCheckPrivacy()
                /* INCASE
                / this.doSetCookie();
                / this.doRedirect();
                */
              } else if (code == 10011) {
                // 10011: security mobile missing
                // redirect to bindMobile page
                this.$store.commit('index/setDataTokn', value)
                this.$emit('update', 'bindM')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.doCloseLoading()
              console.log('ERROR', err)
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/login.scss';
</style>
<style lang="scss">
@import '../styles/form.scss';
</style>



// WEBPACK FOOTER //
// src/views/index/components/loginP.vue